import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { Row, Col, ButtonToolbar, Button, Container, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, sendFlashMessage } from '@/shared/components/flash';
import ApiErrorMessage from '@/shared/components/ApiErrorMessage';

const AddCategory = ({ organization }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onClickCancel = () => {
        history.push('/categories');
    };

    const onSubmit = values => {
        setLoading(true);
        axios.post(`/organization/${organization.id}/category`, values)
            .then(res => {
                if (res.status === 200) {
                    dispatch(sendFlashMessage('Category added successfully', 'alert-success'));
                    history.push('/categories');
                }
            })
            .catch(error => {
                dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response?.data} />, 'alert-danger'));
                setLoading(false);
            });
    };

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <Form onSubmit={onSubmit} validate={validate}>
                                {({ handleSubmit, pristine, submitting }) => (
                                    <form className="form" onSubmit={handleSubmit}>
                                        <Row className="w100">
                                            <Col md="6">
                                                <h3 className="mb-4">Add Category</h3>
                                            </Col>
                                            <Col md="6" className="text-right">
                                                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                                    <Button outline color="primary" className="mr-3" onClick={onClickCancel}>Cancel</Button>
                                                    <Button type="submit" disabled={loading || submitting || pristine} color="primary">Save</Button>
                                                </ButtonToolbar>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="6">
                                                <Field name="name">
                                                    {({ input, meta }) => (
                                                        <div className="form__form-group">
                                                            <span className="form__form-group-label">Category Name</span>
                                                            <div className="form__form-group-field">
                                                                <div className="form__form-group-row">
                                                                    <input type="text" {...input} placeholder="Category Name" />
                                                                    {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </Field>
                                            </Col>
                                        </Row>
                                    </form>
                                )}
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

const validate = values => {
    const errors = {};
    if (!values.name || !values.name.trim()) {
        errors.name = 'Category name is required';
    }
    return errors;
};

export default connect(state => ({
    organization: state.organization
}))(AddCategory);
